import { CurrencyBdtIcon } from './CurrencyBdtIcon';

/**
 * author: Michael Richins
 * id FB0C738C-21DE-4643-9B5D-690CE7AAEAEE
 * name currency-bdt
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-bdt.svg
 * tags
 * - Banking 
 * - Currency 
 */
export const BangladeshiTakaIcon = CurrencyBdtIcon;
export default BangladeshiTakaIcon